<template lang="pug">
.registration-wrapper
	RegistrationForm(v-if="formState == FORM_STATES.FORM", :index-url="indexUrl", @error="setError", @success="setSuccess")
	RegistrationError(v-if="formState == FORM_STATES.TECHNICAL_ERROR", @retry="retry")
	RegistrationSuccess(v-if="formState == FORM_STATES.SUCCESS", :email="email", @retry="retry")
</template>
<script>
import RegistrationForm from './registration-form/registration-form.vue';
import RegistrationError from './registration-error/registration-error.vue';
import RegistrationSuccess from './registration-success/registration-success.vue';
const FORM_STATES = {
	FORM: 'FORM',
	SUCCESS: 'SUCCESS',
	TECHNICAL_ERROR: 'TECHNICAL_ERROR'
};
export default {
	props: {
		indexUrl: {
			required: true
		}
	},
	components: {
		RegistrationForm,
		RegistrationError,
		RegistrationSuccess
	},
	data: () => ({
		formState: FORM_STATES.FORM,
		email: null
	}),
	computed: {
		FORM_STATES: () => FORM_STATES
	},
	methods: {
		retry() {
			this.formState = FORM_STATES.FORM;
		},
		setError() {
			this.formState = FORM_STATES.TECHNICAL_ERROR;
		},
		setSuccess(email) {
			this.formState = FORM_STATES.SUCCESS;
			this.email = email;
		}
	}
};
</script>
